import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation'
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow'
// import ListAltIcon from '@mui/icons-material/ListAlt'
import RotateLeftTwoToneIcon from '@mui/icons-material/RotateLeftTwoTone'
import SearchIcon from '@mui/icons-material/Search'
import {Backdrop, Button, Chip, Modal, TextField} from '@mui/material'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import {DataGridPro, GridColDef, useGridApiRef} from '@mui/x-data-grid-pro'
import {DateRangePicker, LocalizationProvider} from '@mui/x-date-pickers-pro'
import {AdapterDayjs} from '@mui/x-date-pickers-pro/AdapterDayjs'
import {DateRange} from '@mui/x-date-pickers-pro/DateRangePicker'
import {isMobileDevice} from '_metronic/assets/ts/_utils'
import {yMarker} from 'assets/imageDeclear'
import dayjs, {Dayjs} from 'dayjs'
import {envBackHost, hdmBackHost, hdmImageBackHost, serverLocalName} from 'GLOBAL/envVariables'
import {axiosWithAuth} from 'helper/axiosWithAuth'
import fileDownload from 'js-file-download'
import _ from 'lodash'
import {customerHmdTargetListRows} from 'pages/customer/dataConfig/declearRows'
import {targetImageLightBoxStyle} from 'pages/customer/dataConfig/LightBoxConfig'
import React, {useEffect, useRef, useState} from 'react'
import useIsMobile from 'utils/hooks/useIsMobile'
import Lightbox from 'react-image-lightbox'
import 'react-image-lightbox/style.css'
import {useSelector} from 'react-redux'
import {globalConst, globalFormatWithHyphens} from 'utils/const/globalConst'
import {showTemperatureHandler} from 'utils/const/globalController'
import {confirmAlert, resultAlert} from 'utils/CustomAlert/Alert'
import {CustomerDetailChart} from './customerDetailChart'
import {CustomerDetailChartFix} from './CustomerDetailChartFixed'
import './print.css'
/*********************************************************************
 ** Test Data
 *********************************************************************/

/*********************************************************************
 * 1. Init Libs
 *********************************************************************/
const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  height: !isMobileDevice() ? '90%' : '90%',
  bgcolor: 'background.paper',
  overflowY: 'auto',
  // border: '2px solid #000',
  borderRadius: '12px',
  boxShadow: 24,
  p: 4,
}
const CustomerHmdTargetImageListModal = (props: any) => {
  /*********************************************************************
   * 2. State settings (useState)
   *********************************************************************/
  const {data, open, onClose} = props
  const isMobile = useIsMobile()
  const [date, setDate] = React.useState<DateRange<Dayjs>>([null, null])
  const [pageSize, setPageSize] = useState<number>(60)
  const [imageList, setImageList] = useState<any>(null)
  const [loading, setLoading] = useState(false)
  const [selectedOption, setSelectedOption] = useState<any>('reading')
  const officeInfo = useSelector((state: any) => state?.officeInfo)
  const userInfo = useSelector((state: any) => state?.userInfo?.userInfo)
  const [filter, setFilter] = useState<any>({
    startDate: date[0]
      ? date[0]?.format('YYYYMMDD')
      : dayjs().subtract(7, 'day').format('YYYYMMDD'),
    endDate: date[1] ? date[1]?.format('YYYYMMDD') : dayjs().format('YYYYMMDD'),
  })
  const [isZoomOpen, setIsZoomOpen] = useState(false)
  const [selectedImage, setSelectedImage] = useState<any>('')
  const [rows, setRows] = useState<any[]>([])
  const [imageSizeCache, setImageSizeCache] = useState<
    Record<string, {width: number; height: number}>
  >({})
  const [isOnlyImageRows, setIsOnlyImageRows] = useState(false)
  const [isOnlyDataRows, setIsOnlyDataRows] = useState(false)
  /*********************************************************************
   * 3. Handlers (function)
   *********************************************************************/
  /**
   * 이전 수용가 (A)의 데이터가 B 수용가 모달 열었을때 보이던 버그 방지
   * setImageList(null)하나만 실행할경우 반영 제대로 안됨
   * setRows([]) 포함으로 확실하게 초기화 필요
   */
  const onCloseHandler = () => {
    setSelectedImage('') //선택 이미지
    setIsZoomOpen(false) // 줌 모달
    setImageList(null) // 이미지 리스트
    setRows([]) // 테이블 데이터(이미지 사이즈 추가)
    setLoading(false) // 로딩
    setImageSizeCache({}) // ㅇ;ㅁ;ㅈ;ㅋ,ㄱ; 켓;
    onClose() //부모창 모달
    setIsOnlyImageRows(false) //사진만보기
    setIsOnlyDataRows(false) //데이터만보기
  }

  const getImageList = () => {
    setLoading(true) // 로딩 시작
    axiosWithAuth()
      .get(
        `${hdmBackHost}/api/select/${data?.officeId}/customer/${data?.customerNumber}/checkmeter`,
        {
          params: filter,
        }
      )
      .then((res) => {
        const list = res.data.data
        const newRows = customerHmdTargetListRows(list).map((row: any) => {
          const cached = imageSizeCache[row.filePath]
          return cached
            ? {...row, imageWidth: cached.width, imageHeight: cached.height}
            : {...row, imageWidth: null, imageHeight: null}
        })

        setRows(newRows)
        setImageList(list)
        list.forEach((item: any) => {
          if (item.filePath && !imageSizeCache[item.filePath]) {
            const img = new Image()
            img.src = hdmImageBackHost + '/api/select' + item.filePath
            img.onload = () => {
              const {width, height} = img
              setImageSizeCache((prev) => {
                const updated = {
                  ...prev,
                  [item.filePath]: {width, height},
                }
                setRows((prevRows: any[]) =>
                  prevRows.map((r) =>
                    r.filePath === item.filePath
                      ? {...r, imageWidth: width, imageHeight: height}
                      : r
                  )
                )

                return updated
              })
            }
          }
        })
      })
      .finally(() => setLoading(false))
  }

  const handleCellClick = (event: any) => {
    event.stopPropagation()
  }
  const getDownloadData = async () => {
    axiosWithAuth()
      .get(
        `${hdmBackHost}/api/download/${data?.officeId}/customer/${data?.customerNumber}/checkmeter/excel?startDate=${filter.startDate}&endDate=${filter?.endDate}`,
        {
          responseType: 'blob',
        }
      )
      .then(async (res) => {
        await resultAlert({resultCode: 0})
        fileDownload(
          res.data,
          `${globalFormatWithHyphens(data?.officeId, data?.customerNumber)}수용가_${
            filter.startDate
          }~${filter.endDate}_검침상세정보.xlsx`
        )
        await document.getElementById('downloadModalClose')?.click()
      })
      .catch(async (e) => {
        await resultAlert({resultCode: e.response.status})
      })
  }

  const updateCheckValuePost = async (row: any, newValue: string) => {
    const serverHandle = async () => {
      if (['sys_admin', 'sys_user'].includes(userInfo.accountType)) {
        return true
      } else {
        return await confirmAlert('수정', 'info')
      }
    }

    if (await serverHandle()) {
      try {
        const res = await axiosWithAuth().post(`${envBackHost}/checkmeter/update`, {
          idxDate: row.idxDate,
          value: newValue,
          imei: row.imei,
          updateId: userInfo.userId,
        })

        await resultAlert(res.data)

        if (res.data.resultCode === 0) {
          await getImageList()
        }
      } catch (e: any) {
        await resultAlert({resultCode: e.response?.status})
      }
    }
  }

  const accountTypeFixHandler = (type: string) => {
    switch (type) {
      case 'gov_meterman':
      case 'gov_coop':
        return false
      default:
        return true
    }
  }

  const getRowHeightOnDataGrid = (params: any) => {
    const {imageHeight} = params?.model || {}
    // 매핑 테이블
    const heightMap: Record<number, number> = {
      480: 180,
      240: 160,
      144: 110,
    }

    if (imageHeight && heightMap[imageHeight]) {
      return heightMap[imageHeight]
    }
    // 기본값
    return 110
  }

  const buttonColor = (data: string) => {
    switch (data) {
      case 'COMPLETE':
      case 'DIGIT':
        return 'success'
      case 'FAIL':
        return 'error'
      case 'FIX':
        return 'info'
      case 'IMGERR':
        return 'error'
    }
  }
  const gridRef = useRef<HTMLDivElement>(null)

  const scrollToRow = (idxDate: any) => {
    const rowIndex = rows.findIndex((row) => row.idxDate === idxDate)
    if (gridRef.current) {
      const scrollableElement = gridRef.current.querySelector(
        '.MuiDataGrid-virtualScroller'
      ) as HTMLDivElement
      if (scrollableElement) {
        // here and should fin gridRef.current possible
      }
    }
  }

  const handleDateClick = (data: any) => {
    const date = dayjs(data, 'M월 D일').format('MMDD')
    let count = 0
    _.map(imageList, (el, idx) => {
      const column = Object.keys(el)
      return column.findIndex((column) => {
        if (el[column] !== null && el[column].includes(date) && column === 'idxDate') {
          if (count !== 0) {
          } else {
            count++
            return scrollToRow(el[column])
          }
        }
      })
    })
  }

  const apiRef = useGridApiRef()

  /*********************************************************************
   * 4. UseEffect
   *********************************************************************/
  /**
   * 항상 새로운 수용가 데이터를 보장하기 위한 이중 state 요청
   * 이전 이미지 리스트 제거 -> 이전 rows 제거 -> 서버에 새 데이터 요청
   */
  useEffect(() => {
    if (open && data) {
      setImageList(null)
      setRows([])
      getImageList()
    }
  }, [open, data, filter?.startDate, filter?.endDate])

  useEffect(() => {
    const today = dayjs()
    const oneWeekAgo = today.subtract(7, 'day')
    setDate([oneWeekAgo, today])
  }, [])

  useEffect(() => {
    if (open && data && data.latitude && data.longitude) {
      setTimeout(() => {
        if (!window.kakao?.maps) {
          console.log('[CustomerHmdTargetImageListModal] kakao maps not loaded')
          return
        }
        let container = document?.getElementById('map')
        if (container) {
          const map = new window.kakao.maps.Map(container, {
            center: new window.kakao.maps.LatLng(data.latitude, data.longitude),
            mapTypeId: window.kakao.maps.MapTypeId.HYBRID,
            level: 1,
            draggable: false,
            scrollwheel: false,
            zoomable: false,
          })
          const mapTypeControl = new window.kakao.maps.MapTypeControl()
          map.addControl(mapTypeControl, window.kakao.maps.ControlPosition.TOPRIGHT)
          var markerPosition = new window.kakao.maps.LatLng(data.latitude, data.longitude)

          var marker = new window.kakao.maps.Marker({
            position: markerPosition,
            image: new window.kakao.maps.MarkerImage(yMarker, new window.kakao.maps.Size(40, 59)),
          })

          marker.setMap(map)
        }
      }, 300)
    }
  }, [open])

  /*********************************************************************
   * 5. DataGrid Props settings
   *********************************************************************/
  const filteredRows = isOnlyImageRows
    ? rows.filter(
        (row) => row.filePath !== null && row.filePath !== undefined && row.filePath !== ''
      )
    : isOnlyDataRows
    ? rows.filter((row) => row.rsrp !== null || row.rsrq !== null)
    : rows

  const columns: GridColDef[] = [
    {
      field: 'createAt',
      headerName: '검침일시',
      width: 260,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return <div>{dayjs(params?.row?.createAt).format('YYYY-MM-DD HH시 mm분 ss초')}</div>
      },
    },
    {
      field: 'filePath',
      headerName: '검침 이미지',
      width: 250,
      align: 'center',
      headerAlign: 'center',
      hide: data?.deviceType === 'digital',
      renderCell: (params: any) => {
        return (
          <div
            className='cursor-zoom-in'
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              overflow: 'hidden',
            }}
          >
            {params?.row?.filePath === null ? (
              '-'
            ) : (
              <img
                onClick={() => {
                  setIsZoomOpen(true)
                  setSelectedImage(`${hdmImageBackHost}/api/select/${params?.row?.filePath}`)
                }}
                src={`${hdmImageBackHost}/api/select/${params?.row?.filePath}`}
                alt='check'
                style={{
                  maxWidth: '100%',
                  maxHeight: '100%',
                  objectFit: 'contain', // 비율 유지
                  // transform: `rotate(${params?.row?.rotate}deg)`,
                }}
              />
            )}
          </div>
        )
      },
    },

    {
      field: 'checkValue',
      headerName: '검침 값',
      width: 150,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        const isBlank = params.row.processStatus === 'NONE' && params.row.recognizedType === 'PRV'
        return (
          <>
            <div className={'d-flex justify-content-center'}>
              <span>
                {isBlank ? (
                  '-'
                ) : params.row.checkValue === '' || params.row.checkValue === null ? (
                  <span className={'text-danger'}>인식불가</span>
                ) : (
                  params.row.checkValue
                )}
              </span>
              <span>
                {params.row.checkDecimalValue === '' || params.row.checkDecimalValue === null
                  ? ''
                  : '.' + params.row.checkDecimalValue?.split('.')[1]}
              </span>
            </div>
          </>
        )
      },
    },
    {
      field: 'valueUpdate',
      headerName: '검침값 수정',
      width: 280,
      align: 'center',
      headerAlign: 'center',
      hide:
        data?.deviceType === 'digital' ||
        data?.recognizedType === 'PRV' ||
        data?.deviceType === 'hdm',
      renderCell: (params: any) => {
        const rowKey = `${params.row.imei}_${params.row.idxDate}`
        let localInput: HTMLInputElement | null = null
        return (
          <div className='d-flex justify-content-center gap-3' onClick={(e) => handleCellClick(e)}>
            <TextField
              sx={{textAlignLast: 'center'}}
              variant='outlined'
              size='small'
              defaultValue={params.row.checkValue}
              inputRef={(el) => (localInput = el)} // ✅ 콜백 ref
              autoComplete='off'
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  const newVal = localInput?.value || ''
                  updateCheckValuePost(params.row, newVal)
                }
                if (e.ctrlKey && e.key === 'a') e.stopPropagation()
                if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
                  e.stopPropagation()
                }
              }}
              disabled={
                !accountTypeFixHandler(userInfo.accountType) ||
                params.row.processStatus === 'IMGERR'
              }
            />

            {accountTypeFixHandler(userInfo.accountType) && (
              <Button
                variant='contained'
                color={buttonColor(params.row.processStatus)}
                size='small'
                onClick={() => {
                  const newVal = localInput?.value || ''
                  updateCheckValuePost(params.row, newVal)
                }}
                disabled={params.row.processStatus === 'IMGERR'}
              >
                수정
              </Button>
            )}
          </div>
        )
      },
    },
    {
      field: 'temperature',
      headerName: '온도',
      width: 150,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        const temperature = params.row.temperature
        return (
          <>
            <div className={'d-flex justify-content-center'}>
              {temperature !== 99 &&
              temperature !== 0 &&
              temperature !== null &&
              showTemperatureHandler(serverLocalName, officeInfo.value)
                ? `${temperature}°C`
                : '-'}
            </div>
          </>
        )
      },
    },
    {
      field: 'rsrp',
      headerName: '전파세기',
      width: 150,
      align: 'center',
      headerAlign: 'center',
      hide: userInfo.accountType !== 'sys_user' && userInfo.accountType !== 'sys_admin',
      renderCell: (params: any) => {
        const rsrp = params.row.rsrp
        const isWeakRsrp = rsrp < globalConst.rssiWarningdBm
        return (
          <>
            <div
              className={`d-flex justify-content-center ${
                isWeakRsrp ? 'text-orange-500 fw-bold' : ''
              }`}
            >
              {rsrp !== 0 && rsrp !== null ? `${rsrp}dBm` : '-'}
            </div>
          </>
        )
      },
    },
    {
      field: 'rsrq',
      headerName: '전파품질',
      width: 150,
      align: 'center',
      headerAlign: 'center',
      hide: userInfo.accountType !== 'sys_user' && userInfo.accountType !== 'sys_admin',
      renderCell: (params: any) => {
        const rsrq = params.row.rsrq
        const isWeakRsrq = rsrq < globalConst.rsrqGood
        return (
          <>
            <div
              className={`d-flex justify-content-center ${
                isWeakRsrq ? 'text-orange-500 fw-bold' : ''
              }`}
            >
              {rsrq !== 0 && rsrq !== null ? `${rsrq}dB` : '-'}
            </div>
          </>
        )
      },
    },
  ]

  return (
    <Modal
      open={open}
      onClose={() => {
        onCloseHandler()
      }}
      aria-labelledby={`${window.location.pathname}-label`}
      aria-describedby={`${window.location.pathname}-description`}
      closeAfterTransition
      slots={{backdrop: Backdrop}}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
      id={'printTarget'}
      className={'printTarget'}
    >
      <>
        <Box sx={style}>
          <>
            {!isMobileDevice() && (
              <div>
                <div>
                  <div className=''>
                    <div className={'w-100 d-flex justify-content-between'}>
                      <Chip
                        label={`${data?.imei} 검침 상세정보`}
                        variant={'outlined'}
                        sx={{fontSize: '20px', fontWeight: 'bold'}}
                      />
                      <CancelPresentationIcon
                        sx={{fontSize: '40px', cursor: 'pointer'}}
                        color={'error'}
                        onClick={() => {
                          onCloseHandler()
                        }}
                      />
                    </div>

                    <div className=''>
                      {data && (
                        <div className={'d-flex gap-6 col'}>
                          <div className={'col-3'}>
                            <div className={'row mx-0 gap-2'}>
                              <div className={' border border-1 border-gray-400 shadow-sm px-0'}>
                                <Paper
                                  className={'p-4 border-bottom border-1 border-gray-400 '}
                                  square
                                >
                                  <span className='font-semibold text-[1.25rem] text-center'>
                                    수용가 정보
                                  </span>
                                </Paper>
                                <Paper className={'p-4 '} square>
                                  <div className={'row gap-2'}>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span className='font-semibold text-[1.25rem] text-center'>
                                        <DoubleArrowIcon /> 수용가번호
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={globalFormatWithHyphens(
                                          data?.officeId,
                                          data?.customerNumber
                                        )}
                                        inputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span className='font-semibold text-[1.25rem] text-center'>
                                        <DoubleArrowIcon /> 수용가 이름
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={data?.customerName}
                                        inputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span className='font-semibold text-[1.25rem] text-center'>
                                        <DoubleArrowIcon /> 수용가 주소
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={data?.addressRoad}
                                        inputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span className='font-semibold text-[1.25rem] text-center'>
                                        <DoubleArrowIcon /> 계량기 번호
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={data?.meterNumber}
                                        inputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span className='font-semibold text-[1.25rem] text-center'>
                                        <DoubleArrowIcon /> 계량기 구경
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={data?.meterDiameter + 'mm'}
                                        inputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span className='font-semibold text-[1.25rem] text-center'>
                                        <DoubleArrowIcon /> 단말기 IMEI
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={data?.imei}
                                        inputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span className='font-semibold text-[1.25rem] text-center'>
                                        <DoubleArrowIcon /> 단말기 SN
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={data?.serialNumber}
                                        inputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div
                                      className={
                                        'd-flex w-100 justify-content-between align-items-center'
                                      }
                                    >
                                      <span className='font-semibold text-[1.25rem] text-center'>
                                        <DoubleArrowIcon /> 단말기 타입
                                      </span>
                                      <TextField
                                        variant={'outlined'}
                                        className={'mx-2 bg-gray-300'}
                                        value={
                                          data?.deviceType === 'analog'
                                            ? '디지털 이미지'
                                            : data?.deviceType === 'hdm'
                                            ? '일체형 디지털 이미지'
                                            : '디지털'
                                        }
                                        inputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                  </div>
                                </Paper>
                              </div>
                              <div
                                id='map'
                                style={{width: '100%', height: 330}}
                                className={'rounded-2 border-gray-400 border border-1'}
                              />
                            </div>
                          </div>
                          <div className={'col-9'}>
                            <div className={'d-flex gap-2 w-100'}>
                              <LocalizationProvider
                                dateAdapter={AdapterDayjs}
                                localeText={{start: '시작날짜', end: '마지막 날짜'}}
                              >
                                <DateRangePicker
                                  PopperProps={{
                                    style: {
                                      zIndex: 9999,
                                    },
                                  }}
                                  value={date}
                                  calendars={3}
                                  mask='____/__/__'
                                  inputFormat={'YYYY/MM/DD'}
                                  onChange={(newValue) => {
                                    setDate(newValue)
                                    setFilter({
                                      ...filter,
                                      startDate: newValue[0]?.format('YYYYMMDD'),
                                      endDate: newValue[1]?.format('YYYYMMDD'),
                                    })
                                  }}
                                  renderInput={(startProps, endProps) => {
                                    return (
                                      <div className={'d-flex gap-3'}>
                                        <TextField {...startProps} autoComplete={'off'} />
                                        <ArrowForwardIcon className={'align-self-center'} />
                                        <TextField {...endProps} autoComplete={'off'} />
                                      </div>
                                    )
                                  }}
                                />
                              </LocalizationProvider>
                              <Button
                                variant={'contained'}
                                color={'error'}
                                onClick={async () => {
                                  const today = dayjs()
                                  const oneWeekAgo = today.subtract(7, 'day')
                                  setFilter({
                                    ...filter,
                                    startDate: dayjs().subtract(7, 'day').format('YYYYMMDD'),
                                    endDate: dayjs().format('YYYYMMDD'),
                                  })
                                  setDate([oneWeekAgo, today])
                                }}
                              >
                                <RotateLeftTwoToneIcon sx={{width: 24, height: 24}} />
                              </Button>

                              {/* <FormControl sx={{minWidth: 120, height: 24}}>
                                <InputLabel id='select-label'>기준 선택</InputLabel>
                                <Select
                                  labelId='select-label'
                                  id='select'
                                  value={selectedOption}
                                  label='기준 선택'
                                  onChange={(e) => setSelectedOption(e.target.value)}
                                >
                                  <MenuItem value='reading'>검침값</MenuItem>
                                  <MenuItem value='usage'>사용량</MenuItem>
                                </Select>
                              </FormControl> */}

                              <Button variant={'contained'} onClick={() => getImageList()}>
                                <SearchIcon sx={{width: 24, height: 24}} />
                              </Button>
                              {/* <Button
                                variant={'outlined'}
                                color={'success'}
                                startIcon={<ListAltIcon sx={{width: 24, height: 24}} />}
                                onClick={() => getDownloadData()}
                              >
                                Download
                              </Button> */}
                              <Button
                                variant={'outlined'}
                                color={isOnlyImageRows ? 'primary' : 'info'}
                                onClick={() => {
                                  setIsOnlyImageRows((prev) => !prev)
                                  setIsOnlyDataRows(false)
                                }}
                              >
                                {isOnlyImageRows ? '전체보기' : '이미지보기'}
                              </Button>
                              {(userInfo.accountType === 'sys_admin' ||
                                userInfo.accountType === 'sys_user') && (
                                <Button
                                  variant={'outlined'}
                                  color={'secondary'}
                                  onClick={() => {
                                    setIsOnlyDataRows((prev) => !prev)
                                    setIsOnlyImageRows(false)
                                  }}
                                >
                                  {isOnlyDataRows ? '전체보기' : '데이터보기'}
                                </Button>
                              )}
                            </div>

                            <div className={'ps-1'} style={{height: '190px', overflow: 'hidden'}}>
                              {imageList && (
                                <CustomerDetailChartFix
                                  className={'w-100 px-3'}
                                  data={data}
                                  date={date}
                                  imageList={imageList}
                                  filter={filter}
                                  selectedOption={selectedOption}
                                  chartHeight={190}
                                  onDataClick={(e: any) => {
                                    handleDateClick(e)
                                  }}
                                />
                              )}
                            </div>
                            <div className={'pe-3'}>
                              <Box id={'table-content'} sx={{height: 740, width: '100%'}}>
                                <DataGridPro
                                  rows={filteredRows}
                                  columns={columns}
                                  rowHeight={110}
                                  getRowHeight={(params: any) => getRowHeightOnDataGrid(params)}
                                  apiRef={apiRef}
                                  pageSize={pageSize}
                                  onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                  rowsPerPageOptions={[10, 20, 60, 100]}
                                  disableColumnMenu
                                  pagination
                                  loading={loading}
                                />
                              </Box>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {isMobileDevice() && (
              <div className='w-100'>
                <div className={'w-100 d-flex justify-content-between'}>
                  <Chip
                    label={`${data?.imei} 검침 상세정보`}
                    variant={'outlined'}
                    sx={{fontSize: '14px', fontWeight: 'bold'}}
                  />
                  <CancelPresentationIcon
                    sx={{fontSize: '40px', cursor: 'pointer'}}
                    color={'error'}
                    onClick={onCloseHandler}
                  />
                </div>

                <div className=''>
                  {data && (
                    <div className={'row gap-6 col'}>
                      <div className={'col'}>
                        <div className={'row mx-0 gap-2'}>
                          <div className={' border border-1 border-gray-400 shadow-sm px-0'}>
                            <Paper className={'p-4 border-bottom border-1 border-gray-400 '} square>
                              <h2>수용가 정보</h2>
                            </Paper>
                            <Paper className={'p-4 '} square>
                              <div className={'row gap-2'}>
                                <div
                                  className={'row w-100 justify-content-between align-items-center'}
                                >
                                  <h2 className={'d-flex align-items-center gap-2'}>
                                    <DoubleArrowIcon /> 수용가번호
                                  </h2>
                                  <TextField
                                    variant={'outlined'}
                                    className={'mx-2 bg-gray-300'}
                                    value={data?.customerNumber}
                                    inputProps={{
                                      readOnly: true,
                                    }}
                                  />
                                </div>
                                <div
                                  className={'row w-100 justify-content-between align-items-center'}
                                >
                                  <h2 className={'d-flex align-items-center gap-2'}>
                                    <DoubleArrowIcon /> 수용가 이름
                                  </h2>
                                  <TextField
                                    variant={'outlined'}
                                    className={'mx-2 bg-gray-300'}
                                    value={data?.customerName}
                                    inputProps={{
                                      readOnly: true,
                                    }}
                                  />
                                </div>
                                <div
                                  className={'row w-100 justify-content-between align-items-center'}
                                >
                                  <h2 className={'d-flex align-items-center gap-2'}>
                                    <DoubleArrowIcon /> 수용가 주소
                                  </h2>
                                  <TextField
                                    variant={'outlined'}
                                    className={'mx-2 bg-gray-300'}
                                    value={data?.addressRoad}
                                    inputProps={{
                                      readOnly: true,
                                    }}
                                  />
                                </div>
                                <div
                                  className={'row w-100 justify-content-between align-items-center'}
                                >
                                  <h2 className={'d-flex align-items-center gap-2'}>
                                    <DoubleArrowIcon /> 계량기 번호
                                  </h2>
                                  <TextField
                                    variant={'outlined'}
                                    className={'mx-2 bg-gray-300'}
                                    value={data?.meterNumber}
                                    inputProps={{
                                      readOnly: true,
                                    }}
                                  />
                                </div>
                                <div
                                  className={'row w-100 justify-content-between align-items-center'}
                                >
                                  <h2 className={'d-flex align-items-center gap-2'}>
                                    <DoubleArrowIcon /> 계량기 구경
                                  </h2>
                                  <TextField
                                    variant={'outlined'}
                                    className={'mx-2 bg-gray-300'}
                                    value={data?.meterDiameter + 'mm'}
                                    inputProps={{
                                      readOnly: true,
                                    }}
                                  />
                                </div>
                                <div
                                  className={'row w-100 justify-content-between align-items-center'}
                                >
                                  <h2 className={'d-flex align-items-center gap-2'}>
                                    <DoubleArrowIcon /> 단말기 IMEI
                                  </h2>
                                  <TextField
                                    variant={'outlined'}
                                    className={'mx-2 bg-gray-300'}
                                    value={data?.imei}
                                    inputProps={{
                                      readOnly: true,
                                    }}
                                  />
                                </div>
                                <div
                                  className={'row w-100 justify-content-between align-items-center'}
                                >
                                  <h2 className={'d-flex align-items-center gap-2'}>
                                    <DoubleArrowIcon /> 단말기 SN
                                  </h2>
                                  <TextField
                                    variant={'outlined'}
                                    className={'mx-2 bg-gray-300'}
                                    value={data?.serialNumber}
                                    inputProps={{
                                      readOnly: true,
                                    }}
                                  />
                                </div>
                                <div
                                  className={'row w-100 justify-content-between align-items-center'}
                                >
                                  <h2 className={'d-flex align-items-center gap-2'}>
                                    <DoubleArrowIcon /> 단말기 타입
                                  </h2>
                                  <TextField
                                    variant={'outlined'}
                                    className={'mx-2 bg-gray-300'}
                                    value={
                                      data?.deviceType === 'analog'
                                        ? '디지털 이미지'
                                        : data?.deviceType === 'hdm'
                                        ? '일체형 디지털 이미지'
                                        : '디지털'
                                    }
                                    inputProps={{
                                      readOnly: true,
                                    }}
                                  />
                                </div>
                              </div>
                            </Paper>
                          </div>
                          <div
                            id='map'
                            style={{width: '100%', height: 330}}
                            className={'rounded-2 border-gray-400 border border-1'}
                          />
                        </div>
                      </div>
                      <div className={'col'}>
                        <div className={'d-flex gap-2 w-100'}>
                          <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            localeText={{start: '시작날짜', end: '마지막 날짜'}}
                          >
                            <DateRangePicker
                              PopperProps={{
                                style: {
                                  zIndex: 9999,
                                },
                              }}
                              value={date}
                              calendars={3}
                              mask='____/__/__'
                              inputFormat={'YYYY/MM/DD'}
                              onChange={(newValue) => {
                                setDate(newValue)
                                setFilter({
                                  ...filter,
                                  startDate: newValue[0]?.format('YYYYMMDD'),
                                  endDate: newValue[1]?.format('YYYYMMDD'),
                                })
                              }}
                              renderInput={(startProps, endProps) => {
                                return (
                                  <div className={'d-flex gap-3'}>
                                    <TextField {...startProps} autoComplete={'off'} />
                                    <ArrowForwardIcon className={'align-self-center'} />
                                    <TextField {...endProps} autoComplete={'off'} />
                                  </div>
                                )
                              }}
                            />
                          </LocalizationProvider>
                          <div className={'d-flex gap-3'}>
                            <Button
                              variant={'contained'}
                              color={'error'}
                              onClick={async () => {
                                const today = dayjs()
                                const oneWeekAgo = today.subtract(7, 'day')
                                setFilter({
                                  ...filter,
                                  startDate: dayjs().subtract(7, 'day').format('YYYYMMDD'),
                                  endDate: dayjs().format('YYYYMMDD'),
                                })
                                setDate([oneWeekAgo, today])
                              }}
                            >
                              <RotateLeftTwoToneIcon sx={{width: 24, height: 24}} />
                            </Button>
                            <Button variant={'contained'} onClick={() => getImageList()}>
                              <SearchIcon sx={{width: 24, height: 24}} />
                            </Button>
                          </div>
                        </div>
                        <div className={'ps-1'} style={{height: '100%'}}>
                          {imageList && (
                            <CustomerDetailChart
                              className={'w-100 px-3'}
                              data={data}
                              imageList={imageList}
                              filter={filter}
                            />
                          )}
                        </div>
                        <div className={'pe-3'}>
                          <Box id={'table-content'} sx={{height: 600, width: '100%'}}>
                            <DataGridPro
                              rows={rows}
                              columns={columns}
                              rowHeight={110}
                              getRowHeight={(params: any) => getRowHeightOnDataGrid(params)}
                              apiRef={apiRef}
                              pageSize={pageSize}
                              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                              rowsPerPageOptions={[10, 20, 60, 100]}
                              disableColumnMenu
                              pagination
                              loading={loading}
                            />
                          </Box>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </>
        </Box>
        {isZoomOpen && selectedImage && (
          <Lightbox
            mainSrc={selectedImage}
            wrapperClassName='target-image-light-box'
            reactModalStyle={targetImageLightBoxStyle(isMobile)}
            onCloseRequest={() => {
              setIsZoomOpen(false)
              setSelectedImage('')
            }}
          />
        )}
      </>
    </Modal>
  )
}
export default CustomerHmdTargetImageListModal
